import type {
  BookingStatus,
  DamageType,
  ListingCategory,
  ListingSort,
  ListingStatus,
  RentalTab,
} from '@/types/rental.types';

export const RENTAL_TABS: ReadonlyArray<{ key: RentalTab; label: string }> = [
  { key: 'all', label: 'All Listings' },
  { key: 'active', label: 'Active Rentals' },
  { key: 'disputes', label: 'Disputes' },
  { key: 'reported', label: 'Reported' },
  { key: 'removed', label: 'Removed' },
];

/** Tabs backed by the listings endpoint (vs. bookings / disputes). */
export const LISTING_TABS: ReadonlyArray<RentalTab> = ['all', 'reported', 'removed'];

export const CATEGORY_FILTERS: ReadonlyArray<{ key: ListingCategory | ''; label: string }> = [
  { key: '', label: 'All categories' },
  { key: 'entertainment', label: '🎮 Entertainment' },
  { key: 'study', label: '📚 Study' },
  { key: 'electronics', label: '💻 Electronics' },
  { key: 'other', label: '📦 Other' },
];

export const SORTS: ReadonlyArray<{ key: ListingSort; label: string }> = [
  { key: 'newest', label: 'Newest' },
  { key: 'oldest', label: 'Oldest' },
  { key: 'priceDesc', label: 'Price ↓' },
  { key: 'priceAsc', label: 'Price ↑' },
  { key: 'mostRented', label: 'Most rented' },
];

/** Card image: emoji + gradient per category, using mobileApp PhotoSlot tone stripes. */
export const CATEGORY_META: Record<
  ListingCategory,
  { icon: string; label: string; gradient: string }
> = {
  entertainment: { icon: '🎮', label: 'Entertainment', gradient: 'linear-gradient(135deg,#FBE5DF,#F8CFC4)' },
  study: { icon: '📚', label: 'Study', gradient: 'linear-gradient(135deg,#FBE6EE,#F5CFDD)' },
  electronics: { icon: '💻', label: 'Electronics', gradient: 'linear-gradient(135deg,#E4EEFC,#D2E3FA)' },
  other: { icon: '📦', label: 'Other', gradient: 'linear-gradient(135deg,#DEF2E9,#C5EBD8)' },
};

export const LISTING_STATUS_LABEL: Record<
  ListingStatus,
  { label: string; tone: 'success' | 'warn' | 'danger' | 'info' | 'neutral' }
> = {
  live: { label: 'Active', tone: 'success' },
  rented: { label: 'Rented', tone: 'info' },
  pending_approval: { label: 'Pending', tone: 'warn' },
  removed: { label: 'Removed', tone: 'danger' },
};

export const BOOKING_STATUS_LABEL: Record<
  BookingStatus,
  { label: string; tone: 'success' | 'warn' | 'danger' | 'info' | 'neutral' | 'brand' }
> = {
  requested: { label: 'Requested', tone: 'brand' },
  accepted: { label: 'Upcoming', tone: 'info' },
  declined: { label: 'Declined', tone: 'danger' },
  cancelled: { label: 'Cancelled', tone: 'neutral' },
  active: { label: 'Active', tone: 'success' },
  return_initiated: { label: 'Return due', tone: 'warn' },
  returned: { label: 'Returned', tone: 'success' },
  completed: { label: 'Completed', tone: 'neutral' },
};

export const DAMAGE_TYPE_LABEL: Record<DamageType, string> = {
  scratched: 'Scratched',
  broken: 'Broken',
  missing_parts: 'Missing parts',
  stained: 'Stained',
  other: 'Other',
};

export const PAGE_SIZE = 12;
